import { useState } from 'react';

import { BreakpointProvider } from './Breakpoint';

export interface IProviderComposerProps extends React.PropsWithChildren {
  /**
   *  Providers list
   * */
  with: React.FC<React.PropsWithChildren>[];
}

const ComposerFragment = ({ children }: React.PropsWithChildren): JSX.Element => <>{children}</>;

const providerReducer =
  (
    ParentProvider: React.FC<React.PropsWithChildren>,
    ChildProvider: React.FC<React.PropsWithChildren>
  ) =>
  ({ children }: React.PropsWithChildren) =>
    (
      <ParentProvider>
        <ChildProvider>{children}</ChildProvider>
      </ParentProvider>
    );

/**
 * @Component
 * @name ProviderComposer
 * @description Component that receives a list of providers and composes them to a single component.
 */
const ProviderComposer = (props: IProviderComposerProps) => {
  const ComposedProviders = props.with.reduce(providerReducer, ComposerFragment);

  return <ComposedProviders>{props.children}</ComposedProviders>;
};

type Features = 'breakpoint';

export type AppProviderProps = React.PropsWithChildren<{
  features: Features[];
}>;

export const AppProvider = ({ features, children }: AppProviderProps) => {
  const [providers] = useState(() => {
    return features.map((feature) => {
      switch (feature) {
        case 'breakpoint':
          // Breakpoint provider
          return BreakpointProvider;

        default:
          return ComposerFragment;
      }
    });
  });

  return <ProviderComposer with={providers}>{children}</ProviderComposer>;
};

export * from './Breakpoint';
